module.exports = __webpack_public_path__ + "img/robseecoLogo.5903b8f4.png";